export default "__VITE_ASSET__qLSJdqa5__"